import { CURRENCY_SYMBOL_MAP } from '../../../../../../constants/currency'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../../../constants/rentalPortal'
import { formatNumberWithSeparators } from '../../../../../../utils/number'
import { PROVENANCE_FIELD } from '../../../../RentalPortalProvenance'

import {
  LISTING_PROFILE_KEY_FACT,
  LISTING_PROFILE_KEY_FACT_LABEL_KEY,
} from './RentalPortalListingProfileKeyFactsWidget.constants'

function getListingMoneyDisplayValue({ amount, currency }) {
  return amount == null
    ? null
    : `${formatNumberWithSeparators(amount)} ${CURRENCY_SYMBOL_MAP[currency] ?? currency}`
}

function toKeyFact({ key, t, value }) {
  return value == null
    ? null
    : { key, label: t(LISTING_PROFILE_KEY_FACT_LABEL_KEY[key]), value }
}

function getListingHeatingCostsValue({ listing, t }) {
  const value = getListingMoneyDisplayValue({
    amount: listing?.heating_costs,
    currency: listing?.currency,
  })

  return value && listing?.heating_costs_included
    ? `${value} ${t('RentalPortal.ListingProfileHeatingIncludedSuffixKey')}`
    : value
}

function getListingDepositValue(listing) {
  return (
    [
      getListingMoneyDisplayValue({
        amount: listing?.deposit_amount,
        currency: listing?.currency,
      }),
      listing?.deposit_text,
    ]
      .filter(Boolean)
      .join(RENTAL_PORTAL_FACT_SEPARATOR) || null
  )
}

function getListingKeyFactsUnitRows({ listing, t }) {
  const emptyText = t('Select.NoDataKey')

  return [
    {
      key: LISTING_PROFILE_KEY_FACT.rooms,
      label: t(
        LISTING_PROFILE_KEY_FACT_LABEL_KEY[LISTING_PROFILE_KEY_FACT.rooms]
      ),
      provenanceField: PROVENANCE_FIELD.roomCount,
      value:
        listing?.flat?.room_count == null
          ? emptyText
          : formatNumberWithSeparators(listing.flat.room_count),
    },
    {
      key: LISTING_PROFILE_KEY_FACT.area,
      label: t(
        LISTING_PROFILE_KEY_FACT_LABEL_KEY[LISTING_PROFILE_KEY_FACT.area]
      ),
      provenanceField: PROVENANCE_FIELD.area,
      value:
        listing?.flat?.area == null
          ? emptyText
          : `${formatNumberWithSeparators(listing.flat.area)} ${t('Common.AreaUnitKey')}`,
    },
  ]
}

function getListingKeyFactsPriceRows({ listing, t }) {
  const currency = listing?.currency

  return [
    {
      key: LISTING_PROFILE_KEY_FACT.rentCold,
      value: getListingMoneyDisplayValue({
        amount: listing?.rent_price,
        currency,
      }),
    },
    {
      key: LISTING_PROFILE_KEY_FACT.serviceCharge,
      value: getListingMoneyDisplayValue({
        amount: listing?.service_charge,
        currency,
      }),
    },
    {
      key: LISTING_PROFILE_KEY_FACT.heatingCosts,
      value: getListingHeatingCostsValue({ listing, t }),
    },
    {
      key: LISTING_PROFILE_KEY_FACT.otherCosts,
      value: getListingMoneyDisplayValue({
        amount: listing?.other_costs,
        currency,
      }),
    },
    {
      key: LISTING_PROFILE_KEY_FACT.rentWarm,
      value: getListingMoneyDisplayValue({
        amount: listing?.warmmiete_derived,
        currency,
      }),
    },
    {
      key: LISTING_PROFILE_KEY_FACT.deposit,
      value: getListingDepositValue(listing),
    },
  ]
    .map(({ key, value }) => toKeyFact({ key, t, value }))
    .filter(Boolean)
}

export function getIsListingKeyFactsRentWarmRow(key) {
  return key === LISTING_PROFILE_KEY_FACT.rentWarm
}

export function getListingKeyFactsRows({ listing, t }) {
  return [
    ...getListingKeyFactsUnitRows({ listing, t }),
    ...getListingKeyFactsPriceRows({ listing, t }),
  ]
}
